import React, { useState, useEffect, useContext } from "react";
import Spinner from "react-bootstrap/Spinner";
import Modal from "react-bootstrap/Modal";
import qahoy from "views_shared/app/javascript/scripts/qahoy";
import qapi from "views_shared/app/javascript/api";
import { CompanyContext } from "../data/company_context_management";
import ExpertForm from "./expert_form";

function ExpertsForm() {
  const perPage = 9999;
  const [asyncError, setAsyncError] = useState();
  const [doExpertsFetch, setDoExpertsFetch] = useState(true);
  const [experts, setExperts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  const { companyId, setOpenEditModal, setGeneralError, isUpdating } = useContext(CompanyContext);

  const sortExpertsByName = (exps) =>
    exps.sort((exp1, exp2) => {
      const exp1Name = exp1.person_name;
      const exp2Name = exp2.person_name;
      return exp1Name.localeCompare(exp2Name);
    });

  // Set Modal fixed height to stay within viewport in order to show modal footer without having to scroll
  useEffect(() => {
    const setModalHeight = () => {
      document.querySelector(".modal-content").style.maxHeight = "90vh";
    };
    setModalHeight();
  }, []);

  useEffect(() => {
    const fetchExperts = async () => {
      if (!doExpertsFetch) return;
      if (companyId) {
        setIsLoading(true);
        qahoy.track("ExpertsForm#fetchExperts");

        const params = {
          page: 1,
          per_page: perPage,
        };

        const response = await qapi.companyJobs.getAllByCompany(companyId, params);
        if (response.data) {
          const expertResults = response.data;

          if (expertResults.length > 0) {
            const sorted = sortExpertsByName(expertResults);
            setExperts(sorted);
          }
          setDoExpertsFetch(false);
        } else if (response.error) {
          setAsyncError(response.error);
        } else {
          throw new Error();
        }

        setIsLoading(false);
      }
    };

    fetchExperts();
  }, [companyId, doExpertsFetch]);

  const renderExperts = () => {
    if (!experts.length) return null;

    // One mapping for both the full list and a name search — the search branch used to render
    // ExpertForm with a prop shape it doesn't accept, so searched rows arrived blank.
    const searchedName = searchTerm.toLowerCase();
    return experts
      .filter((cj) => searchTerm === "" || cj.person_name.toLowerCase().includes(searchedName))
      .map((cj) => (
        // Note: each row is a company JOB, not a person — see the API call above.
        <ExpertForm
          companyHidden={cj.company_hidden}
          companyHighlighted={cj.company_highlighted}
          companyId={cj.company_id}
          companyJobId={cj.id}
          endedAt={cj.ended_at}
          key={cj.id}
          personName={cj.person_name}
          personProfileImageUrl={cj.person_profile_image_url}
          setDoExpertsFetch={setDoExpertsFetch}
          title={cj.title}
        />
      ));
  };

  const closeModal = () => {
    setOpenEditModal(null);
    setGeneralError(null);
  };

  // Let top-level ErrorBoundary see any async errors
  if (asyncError) throw asyncError;

  return (
    <>
      <Modal.Body className="p-1" style={{ overflowY: "scroll" }}>
        <div className="mb-3">
          <input
            type="text"
            className="form-control"
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search by name"
            value={searchTerm}
          />
        </div>

        {renderExperts()}

        {isLoading && (
          <div className="row d-flex justify-content-center">
            <Spinner
              variant="primary"
              animation="border"
              className="me-2 mb-3"
              style={{
                width: "2.5rem",
                height: "2.5rem",
              }}
            />
          </div>
        )}
      </Modal.Body>

      <Modal.Footer>
        <button type="button" className="btn btn-secondary" onClick={closeModal} disabled={isUpdating}>
          Close
        </button>
      </Modal.Footer>
    </>
  );
}

export default ExpertsForm;
